import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowOutLogout12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconArrowOutLogout12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M1 2.5A1.5 1.5 0 0 1 2.5 1h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 1 9.5zM4.5 6a.5.5 0 0 1 .5-.5h4.173L7.896 4.224a.5.5 0 1 1 .708-.707l2.12 2.12.354.354-.353.354-2.121 2.121a.5.5 0 1 1-.708-.707L9.156 6.5H5a.5.5 0 0 1-.5-.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowOutLogout12);
